import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from 'utils/translations';
import { PlatformClient } from '../httpClients/PlatformClient/PlatformClient';
import { QUERY_KEYS } from '../queries/consts';
import { queryClient } from '../queryClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

export const useDeleteTeamMutation = () => {
  const spawnToasts = spawn('toasts.teams.delete-team');

  return useMutation({
    mutationKey: [MUTATION_KEYS.DELETE_TEAM],
    mutationFn: async (teamId: string) => {
      return await PlatformClient.deleteTeam(teamId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.ORGANIZATION_TEAMS],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.USER_TEAMS],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.ORGANIZATION_MEMBERS],
      });
      toast.success(spawnToasts('success'));
    },
    onError: (err) => {
      toast.error(getErrorToastContent(err, spawnToasts('error')));
    },
  });
};
